import React from "react";

import leftEye1 from "../images/leftEye/leftEye1.png";
import leftEye2 from "../images/leftEye/leftEye2.png";
import leftEye3 from "../images/leftEye/leftEye3.png";
import leftEye4 from "../images/leftEye/leftEye4.png";

import leftEyebrow1 from "../images/leftEyebrow/leftEyebrow1.png";
import leftEyebrow2 from "../images/leftEyebrow/leftEyebrow2.png";
import leftEyebrow3 from "../images/leftEyebrow/leftEyebrow3.png";
import leftEyebrow4 from "../images/leftEyebrow/leftEyebrow4.png";
import leftEyebrow5 from "../images/leftEyebrow/leftEyebrow5.png";

import rightEye1 from "../images/rightEye/rightEye1.png";
import rightEye2 from "../images/rightEye/rightEye2.png";
import rightEye3 from "../images/rightEye/rightEye3.png";
import rightEye4 from "../images/rightEye/rightEye4.png";

import rightEyebrow1 from "../images/rightEyebrow/rightEyebrow1.png";
import rightEyebrow2 from "../images/rightEyebrow/rightEyebrow2.png";
import rightEyebrow3 from "../images/rightEyebrow/rightEyebrow3.png";
import rightEyebrow4 from "../images/rightEyebrow/rightEyebrow4.png";
import rightEyebrow5 from "../images/rightEyebrow/rightEyebrow5.png";

import nose1 from "../images/nose/nose1.png";
import nose2 from "../images/nose/nose2.png";
import nose3 from "../images/nose/nose3.png";
import nose4 from "../images/nose/nose4.png";

import mouth1 from "../images/mouth/mouth1.png";
import mouth2 from "../images/mouth/mouth2.png";
import mouth3 from "../images/mouth/mouth3.png";
import mouth4 from "../images/mouth/mouth4.png";
import mouth5 from "../images/mouth/mouth5.png";
import mouth6 from "../images/mouth/mouth6.png";

export const leftEyeData = {
  name: "leftEye",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: leftEye1,
      label: (
        <div>
          <img src={leftEye1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEye2,
      label: (
        <div>
          <img src={leftEye2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEye3,
      label: (
        <div>
          <img src={leftEye3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEye4,
      label: (
        <div>
          <img src={leftEye4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};

export const leftEyebrowData = {
  name: "leftEyebrow",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: leftEyebrow1,
      label: (
        <div>
          <img src={leftEyebrow1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEyebrow2,
      label: (
        <div>
          <img src={leftEyebrow2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEyebrow3,
      label: (
        <div>
          <img src={leftEyebrow3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEyebrow4,
      label: (
        <div>
          <img src={leftEyebrow4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: leftEyebrow5,
      label: (
        <div>
          <img src={leftEyebrow5} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};

export const rightEyeData = {
  name: "rightEye",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: rightEye1,
      label: (
        <div>
          <img src={rightEye1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEye2,
      label: (
        <div>
          <img src={rightEye2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEye3,
      label: (
        <div>
          <img src={rightEye3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEye4,
      label: (
        <div>
          <img src={rightEye4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};

export const rightEyebrowData = {
  name: "rightEyebrow",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: rightEyebrow1,
      label: (
        <div>
          <img src={rightEyebrow1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEyebrow2,
      label: (
        <div>
          <img src={rightEyebrow2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEyebrow3,
      label: (
        <div>
          <img src={rightEyebrow3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEyebrow4,
      label: (
        <div>
          <img src={rightEyebrow4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: rightEyebrow5,
      label: (
        <div>
          <img src={rightEyebrow5} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};

export const noseData = {
  name: "nose",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: nose1,
      label: (
        <div>
          <img src={nose1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: nose2,
      label: (
        <div>
          <img src={nose2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: nose3,
      label: (
        <div>
          <img src={nose3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: nose4,
      label: (
        <div>
          <img src={nose4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};

export const mouthData = {
  name: "mouth",
  featureArray: [
    { value: "empty", label: <div>---</div> },
    {
      value: mouth1,
      label: (
        <div>
          <img src={mouth1} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: mouth2,
      label: (
        <div>
          <img src={mouth2} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: mouth3,
      label: (
        <div>
          <img src={mouth3} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: mouth4,
      label: (
        <div>
          <img src={mouth4} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: mouth5,
      label: (
        <div>
          <img src={mouth5} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
    {
      value: mouth6,
      label: (
        <div>
          <img src={mouth6} height="30px" width="30px" alt={""} />
        </div>
      ),
    },
  ],
};
